import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from '../../../global';

import { media } from '../../../services/media';
import { themeStyles } from '../../../services/themeStyles';

const FormueStyles = themeStyles(
    'formue',
    css`
        background: ${colors.pampas};
    `,
);

const UpscoreStyles = themeStyles(
    'upscore',
    css`
        background-image: url(/assets/images/ellipse-placeholder-menu-1.png);

        &:after {
            content: '';

            display: block;

            width: 100%;
            padding-top: 94%;
        }
    `,
);

export const Background = styled.div`
    width: 100vw;
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    background-position: top right;
    background-size: cover;

    ${media.max('md')} {
        max-width: 400px;
    }

    ${media.between('md', 'lg')} {
        max-width: 600px;
    }

    ${media.min('lg')} {
        max-width: 900px;
    }

    ${UpscoreStyles}
    ${FormueStyles}
`;
